import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Checkbox, Chip, Typography } from '@mui/material';
import { type Components, type Theme } from '@mui/material/styles';

const MuiAutocomplete: Components<Theme>['MuiAutocomplete'] = {
  defaultProps: {
    popupIcon: <KeyboardArrowDownIcon />,
    /**
     * Отрисовка тэгов
     * @param value Значение
     * @param getTagProps Дефолтные пропсы
     */
    renderTags: (value, getTagProps) => {
      const MAX_VISIBLE_TAGS = 2;
      const visibleTags = value.slice(0, MAX_VISIBLE_TAGS);
      const hiddenCount = value.length - MAX_VISIBLE_TAGS;

      return [
        ...visibleTags.map((option, index) => (
          <Chip
            label={option.name}
            {...getTagProps({ index })}
            key={option.id}
          />
        )),
        hiddenCount > 0 && (
          <Typography ml={1} key='more'>{`ещё ${hiddenCount}...`}</Typography>
        )
      ];
    },
    /**
     * Отрисовка опции
     * @param props Пропсы
     * @param option Данные опции
     * @param root0 Состояние опции
     * @param root0.selected Выбрана ли опция
     */
    renderOption: (props, option, { selected }) => (
      <li {...props} key={option.id}>
        <Checkbox style={{ marginRight: 8 }} checked={selected} />
        {option.name}
      </li>
    ),
    /**
     * Получение заголовка
     * @param option Данные опции
     */
    getOptionLabel: option => option.name
  },
  styleOverrides: {
    /**
     * Шеврон раскрытия. Ниже md тап-зона добирает до 44px: MUI даёт 28×28
     * (padding 2 + иконка 24), и на телефоне попасть в него было трудно.
     * От md значения прежние — десктоп не меняется.
     *
     * Медиазапрос здесь безопасен: свойства width/height у `popupIndicator`
     * ни один консьюмер не выставляет (проверено грепом), поэтому перебить
     * безусловное объявление в `sx` этот `@media` не может.
     * @param root0 Пропсы
     * @param root0.theme Тема
     */
    popupIndicator: ({ theme }) => ({
      [theme.breakpoints.down('md')]: {
        width: 44,
        height: 44
      }
    })
  }
};

export const autocomplete = { MuiAutocomplete };
